import { BaseController } from "../../common/base/controller";
import { NewBankModel } from "./bank.model";
import { Accounts } from "./accounts";
import { ProgressableStates } from "../../app.state";
import _ from "lodash";

export class StartController extends BaseController {
	form = {};
	steps;

	constructor(controllerService, configService, accountIdValidationService) {
		"ngInject";
		super({
			controllerService,
			configService,
			accountIdValidationService,
		});

		this.steps = [
			{
				title: "app.start.step.transfer.title",
				description: "app.start.step.transfer.description",
			},
			{
				title: "app.start.step.data.title",
				description: "app.start.step.data.description",
			},
			{
				title: "app.start.step.submit.title",
				description: "app.start.step.submit.description",
			},
		];
	}

	get tenantName() {
		return this.configService.getName();
	}

	get teaserUrl() {
		return this.appConfig.get().app.teaser;
	}

	get bothAccountsHaveSameType() {
		return this.form.$submitted && this.accounts.bothAccountsHaveSameType;
	}

	get bothAccountsHaveSameNumber() {
		return this.form.$submitted && this.accounts.bothAccountsHaveSameNumber;
	}

	get showAddButton() {
		return this.configService.isFeatureActive(this.Features.additionalAccount);
	}

	get showFinanceTypeInfo() {
		return this.configService.isFeatureActive(
			this.Features.showFinanceTypeInfo,
		);
	}

	get askForConsultantEmailAddress() {
		return this.configService.isFeatureActive(
			this.Features.askForConsultantEmailAddress,
		);
	}

	get showStartOpenSecuritiesAccountInfo() {
		return this.configService.isFeatureActive(
			this.Features.showStartOpenSecuritiesAccountInfo,
		);
	}

	get featureUserDataReadonly() {
		return this.configService.isFeatureActive(this.Features.userDataReadOnly);
	}

	get showTradeRepublicHint() {
		return this.configService.isFeatureActive(
			this.Features.tradeRepublicUnsupportedHint,
		);
	}

	get securitiesAccountUrl() {
		return this.configService.getFeature(this.Features.securitiesAccountUrl);
	}

	get investmentAccountUrl() {
		return this.configService.getFeature(this.Features.investmentAccountUrl);
	}

	setupBlzValidations() {
		this.blzMessages = {
			required: "app.start.error.blz.required",
			blz: "app.start.error.blz",
		};

		this.consultantEmailMessages = {
			email: "app.start.error.email",
		};

		this.blzOptions = { validate: "blz" };
	}

	get showBlzInput() {
		return this.configService.isFeatureActive(this.Features.showBlzInput);
	}

	get helpItem() {
		return this.configService.isFeatureActive(this.Features.showHelpItem);
	}

	get showTransferInfoIcon() {
		return this.configService.isFeatureActive(
			this.Features.showTransferInfoIcon,
		);
	}

	$onInit() {
		// this.selection = true;
		this.transferAllSecurities = this.appCache.get("transferAllSecurities");
		this.newBank = new NewBankModel(this.appCache.get("newBank") || {});
		this.financeTypes = ["portfolioId", "investmentId"];
		this.accounts = new Accounts(this.financeTypes, this.form);
		this.progressbarStates = ProgressableStates(
			this.configService.isFeatureActive(this.Features.hasStatusPage),
		);

		// Set default value for transferAllSecurities
		if (typeof this.transferAllSecurities !== "boolean") {
			this.transferAllSecurities = true;
		}

		this.setupBlzValidations();

		this.translations(this.$translate);

		if (this.configService.isFeatureActive(this.Features.prefillBankCode))
			this.blz =
				this.configService.config && this.configService.config.bankCode;

		// Prefill cached values
		if (this.newBank && this.newBank.orderOfAccountFields) {
			this.accounts.accounts = this.newBank.orderOfAccountFields.accounts;
			this.selection = true;
		}
	}

	submit() {
		// mark form as submitted
		this.form.$submitted = true;
		if (this.accounts.length > 1) {
			if (
				this.accounts.bothAccountsHaveSameType ||
				this.accounts.bothAccountsHaveSameNumber
			) {
				this.form.$invalid = true;
				return;
			}
		}

		if (this.form.$valid) {
			this.accounts.copyAccountsToObject(this.newBank);
			if (this.blz) {
				this.newBank.blz = this.blz;
			}
			if (this.consultantEmail) {
				this.newBank.consultantEmail = this.consultantEmail;
			}
			this.newBank.orderOfAccountFields = this.accounts;

			this.validatingAccountNumber = true;
			this.newAccountIdValidationError = false;

			this.accountIdValidationService
				.checkAccountId(this.newBank.portfolioId)
				.then(
					(success) => this.accountValid(),
					(error) => this.accountInvalid(error),
				)
				.finally(() => {
					this.validatingAccountNumber = false;
				});
		}
	}

	accountValid() {
		delete this.financeTypes;
		this.newBank.shortName = this.tenantName;
		this.appCache.set("newBank", this.newBank);
		this.appCache.set("transferAllSecurities", !!this.transferAllSecurities);
		this.nextState();
	}

	accountInvalid(error) {
		this.newAccountIdValidationError = error.data;
	}

	translations(translate) {
		const self = this;
		translate("app.start.button.exists", { tenant: this.tenantName }).then(
			(translation) => {
				self.accountExistsLabel = translation;
			},
		);

		translate("app.start.button.open", { tenant: this.tenantName }).then(
			(translation) => {
				self.accountOpenLabel = translation;
			},
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/start/start.controller.js